import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { BookingApi, DynamicPriceListDTO } from '@lkp/parking-sdk';
import { Subject, takeUntil } from 'rxjs';
import { BOOKING_API } from 'src/app/core/providers/api.module';
import {
  extractStatus,
  normalizeErrorMessage,
} from 'src/app/core/utils/error-normalize';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';

export interface BookingPricelistDialogData {
  bookingId: number;
}

@Component({
  selector: 'app-booking-pricelist-dialog',
  templateUrl: './booking-pricelist-dialog.component.html',
  styleUrls: ['./booking-pricelist-dialog.component.scss'],
  standalone: false,
})
export class BookingPricelistDialogComponent implements OnInit, OnDestroy {
  readonly displayedColumns = ['days', 'price'];
  readonly onDestroy$ = new Subject<void>();
  loading = true;
  priceList?: DynamicPriceListDTO;

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: BookingPricelistDialogData,
    @Inject(BOOKING_API) private bookingApi: BookingApi,
    private dialogRef: MatDialogRef<BookingPricelistDialogComponent>,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.bookingApi
      .getBookingDynamicPriceList({ bookingId: this.data.bookingId })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (priceList) => {
          this.priceList = priceList;
          this.loading = false;
        },
        error: (error) => {
          this.dialogRef.close();
          this.dialog.open(ErrorDialogComponent, {
            data: {
              title: 'Det gick inte att hämta prislistan',
              message: [
                extractStatus(error) === 404
                  ? 'Prislistan för bokningen kunde inte hittas.'
                  : normalizeErrorMessage(error),
              ],
            },
          });
        },
      });
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
